import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'hypnose_aff_settings';

const DEFAULTS = {
  voiceMode: 'sans-voix', // 'ludovic' | 'mon-choix' | 'sans-voix'
  intervalSec: 10,        // 0 | 10 | 15 | 30
};

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULTS, ...parsed };
  } catch {
    return { ...DEFAULTS };
  }
}

/**
 * Persisted user settings for Affirmations playback:
 *  - voiceMode: which voice to auto-play
 *  - intervalSec: silence between affirmations (mental repetition)
 */
export default function useAffirmationSettings() {
  const [settings, setSettings] = useState(load);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(settings)); }
    catch (e) { console.warn('[useAffirmationSettings] Failed to persist:', e); }
  }, [settings]);

  const update = useCallback((patch) => {
    setSettings((prev) => ({ ...prev, ...patch }));
  }, []);

  return { settings, update };
}
